import { render, staticRenderFns } from "./component-layout.vue?vue&type=template&id=ecc5ac72&scoped=true&lang=true&"
import script from "./component-layout.vue?vue&type=script&lang=js&"
export * from "./component-layout.vue?vue&type=script&lang=js&"
import style0 from "./component-layout.vue?vue&type=style&index=0&id=ecc5ac72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc5ac72",
  null
  
)

export default component.exports